(function () {
	'use strict';

	angular.module('app.core')
		.directive('createProcurementTask', createProcurementTask);
	
	createProcurementTask.$inject = [];
	function createProcurementTask() {
		return {
			restrict: 'EA',
			controller: createProcurementTaskCtrl,
			controllerAs: 'createProcurementTaskCtrl',
			bindToController: true
		};
	}

	createProcurementTaskCtrl.$inject = ['$rootScope', '$scope', '$uibModal', '$location', '$experiments', 'procurementTaskService', 
		'watcherFunctionsService', 'notificationService'];
	function createProcurementTaskCtrl($rootScope, $scope, $uibModal, $location, $experiments, procurementTaskService,
			watcherFunctionsService, notificationService) {
		var vm = this;
		var modal, factoryNdx, row, rowIndex, inventoryActionType, fullItemCode, incomingLocation, specificTaskType, itemNdx = undefined;
		var defaultDate = new Date();
		defaultDate.setDate(defaultDate.getDate() + 30);

		// Watcher Tagging
		vm.watchersObject = {
			suffixForTagging: '',
			prefixForTagging: '',
			emailSuffix: undefined,
			tempWatchers: {},
			displayNoUsersFound: false
		};

		vm.itemHyperlink = undefined;
		vm.formatTagResult = watcherFunctionsService.formatTagResult;
		vm.getUsersForTagging = watcherFunctionsService.getUsersForTagging;
		vm.itemCodeDisplay = undefined;
		fullItemCode = undefined;
		vm.newTask = {};
		vm.closeModal = closeModal;
		vm.createTask = createTask;
		vm.tagTransform = tagTransform;
		vm.refreshCategoryResults = refreshCategoryResults;
		vm.formSubmitting = false;
		vm.dueDateOptions = {
			minDate: new Date(Date.now()),
			showWeeks: false
		};

		$rootScope.$on('createProcurementTask', function(event, incomingInfo) {
			vm.formSubmitting = false;
			setInfo(incomingInfo);
			openModal();
		});

		function clearWatcherInfo() {
			vm.watchersObject.suffixForTagging = '';
			vm.watchersObject.prefixForTagging = '';
			vm.watchersObject.tempWatchers = {};
		}

		function setInfo(incomingInfo) {
			closeModal();
			clearWatcherInfo();
			vm.newTask = {dueDate: defaultDate};
			inventoryActionType = incomingInfo.inventoryActionType;
			if (factoryNdx !== incomingInfo.factoryNdx) {
				factoryNdx = incomingInfo.factoryNdx;
				loadListData();
			} else {
				vm.newTask.selectedUser = _.find(vm.users, {searchString: globalConfig.user.lastName + ', ' + globalConfig.user.firstName});
				vm.newTask.selectedStatus = vm.statuses[0];
				if (inventoryActionType && inventoryActionType.length) {
					vm.newTask.subject = inventoryActionType;
					var currentIACategory = _.find(vm.categories, {name: inventoryActionType});
					vm.newTask.selectedCategory = currentIACategory ? currentIACategory : {
						name: inventoryActionType
					};
				}
			}
			specificTaskType = incomingInfo.specificTaskType;
			itemNdx = incomingInfo.itemNdx;
			vm.itemCodeDisplay = incomingInfo.itemCodeDisplay;
			fullItemCode = incomingInfo.fullItemCode;
			row = incomingInfo.row;
			rowIndex = incomingInfo.rowIndex;
			incomingLocation = incomingInfo.incomingLocation;
			vm.itemHyperlink = '/application/f/home.html#/item-drilldown?itemCode=' + fullItemCode + '&factoryNdx=' + factoryNdx;
		}

		function openModal() {
			// Open the form
			var opts = {
				templateUrl: '/application/f/core/procurement-tasks/create-procurement-task.html',
				backdrop: 'static'
			};
			modal = $uibModal.open(opts);
		}

		function closeModal() {
			if (modal) {
				modal.close();
				modal = undefined;
			}
		}

		function loadListData() {
			vm.categories = [];
			vm.statuses = [];
			vm.users = [];
			vm.watchersObject.emailSuffix = undefined;

			procurementTaskService.getEmailSuffix(factoryNdx).then(function(suffix) {
				vm.watchersObject.emailSuffix = suffix;
			});

			procurementTaskService.getCategories(factoryNdx).then(function (data) {
				vm.categories = data || [];
				_.map(vm.categories, function(category) {
					category.name = strip(category.name);
				});
				if (inventoryActionType && inventoryActionType.length) {
					vm.newTask.subject = inventoryActionType;
					var currentIACategory = _.find(vm.categories, {name: inventoryActionType});
					vm.newTask.selectedCategory = currentIACategory ? currentIACategory : {
						name: inventoryActionType
					};
				}
			});

			procurementTaskService.getStatuses(factoryNdx).then(function (data) {
				vm.statuses = data.map(function (st) {
					st.displayName = st.name;
					if (st.name === 'Review Later') st.displayName = 'In Progress';
					return st;
				}) || [];
				vm.newTask.selectedStatus = vm.statuses[0];
			});

			procurementTaskService.getUsers(factoryNdx).then(function (data) {
				if (!Array.isArray(data)) {
					vm.users = [];
				};
				vm.users = data.filter(function(user) {
					return user.roleType !== 'Supplier';
				});
				_.map(vm.users, function(user) {
					user.searchString = user.lastName + ', ' + user.firstName;
				});
				vm.newTask.selectedUser = _.find(vm.users, {searchString: globalConfig.user.lastName + ', ' + globalConfig.user.firstName});
			});
		}

		function addCategory(category) {
			var cat = {};
			cat.name = strip(category.name);
			return procurementTaskService.addCategory(cat, factoryNdx)
				.then(function (data) {
					category.id = data.val;

				});
		}

		function updateRowData(saveObject, data) {
			var updateRowsObject = {};
			updateRowsObject.identifier = {
				itemNdx: row.itemNdx
			};
			// Merge actionCount against the existing row so Task Status shows the multi-task badge (React parity).
			updateRowsObject.incrementActionCount = specificTaskType !== 'action';
			updateRowsObject.newValues = {};
			// Update the rows variables
			updateRowsObject.newValues.actionStatus = vm.newTask.selectedStatus.name;
			updateRowsObject.newValues.actionStatusNdx = vm.newTask.selectedStatus.id;
			updateRowsObject.newValues.actionStatusIcon = procurementTaskService.iconMap[vm.newTask.selectedStatus.name];
			updateRowsObject.newValues.actionStatusTip = procurementTaskService.iconTooltip[vm.newTask.selectedStatus.name];
			updateRowsObject.newValues.actionOwner = strip(vm.newTask.selectedUser.firstName + ' ' + vm.newTask.selectedUser.lastName);
			updateRowsObject.newValues.actionOwnerNdx = vm.newTask.selectedUser.ndx;
			updateRowsObject.newValues.actionSubject = vm.newTask.subject;
			updateRowsObject.newValues.actionDescription = vm.newTask.description;
			updateRowsObject.newValues.responsibleNdx = vm.newTask.selectedUser.ndx;
			updateRowsObject.newValues.actionDueDate = parseInt(strip(saveObject.dueDate));
			updateRowsObject.newValues.actionIsActive = true;
			if (specificTaskType !== 'action') {
				updateRowsObject.newValues.taskId = data.id;
			}
			updateRowsObject.newValues.actionCategory = vm.newTask.selectedCategory.name;
			updateRowsObject.newValues.actionCategoryNdx = vm.newTask.selectedCategory.id;
			updateRowsObject.newValues.lastComment = '';
			updateRowsObject.newValues.lastCommentDate = undefined;
			updateRowsObject.newValues.lastCommenter = '';
			$rootScope.$broadcast('updateRows', updateRowsObject);
			// Legacy reports
			var statusIcon = jQuery('#actionStatus' + rowIndex).children().children('i');
			var statusText = jQuery('#actionStatus' + rowIndex).children().children('span');
			var tooltipHolder = jQuery('#actionStatus' + rowIndex).children();
			if (statusIcon.hasClass('fa-plus')) {
				statusIcon.removeClass('fa-plus');
				statusIcon.addClass('fa-pencil');
			}
			statusText.html(vm.newTask.selectedStatus.name);
			tooltipHolder.attr('title', procurementTaskService.iconTooltip[vm.newTask.selectedStatus.name]);
			tooltipHolder.removeClass('grayColor');
		}

		function createTask() {
			vm.formSubmitting = true;
			if (typeof vm.newTask.dueDate === 'undefined') {
				$rootScope.$emit('toast', {
					'message': 'The date entered is not valid, please enter a valid date.',
					'success': false
				});
				vm.formSubmitting = false;
				return;
			}

			var saveObject = {};
			saveObject.type = 'PROCUREMENT';
			saveObject.subject = vm.newTask.subject;
			saveObject.description = vm.newTask.description;
			saveObject.categoryNdx = vm.newTask.selectedCategory.id;
			saveObject.statusNdx = vm.newTask.selectedStatus.id;
			saveObject.ownerNdx = vm.newTask.selectedUser.ndx;
			var dateForLogging = vm.newTask.dueDate;
			var selectedDateUtc = moment(new Date(vm.newTask.dueDate).setHours(18)).subtract(new Date().getTimezoneOffset(), 'minutes');
			saveObject.dueDate = selectedDateUtc.valueOf();
			saveObject.itemNdx = itemNdx;
			saveObject.itemCode = fullItemCode;
			saveObject.watchers = watcherFunctionsService.getWatchersIfAny(-1, saveObject.description, vm.watchersObject);
			var matchedCategory = procurementTaskService.findExistingCategory(vm.categories, vm.newTask.selectedCategory);
			if (!matchedCategory) {
				addCategory(vm.newTask.selectedCategory)
					.then(function () {
						if (!vm.newTask.selectedCategory.id || vm.newTask.selectedCategory.id === -1) {
							$rootScope.$emit('toast', {
								'message': 'Task Category was not created, please try again',
								'success': false
							});
							return;
						}
						saveObject.categoryNdx = vm.newTask.selectedCategory.id;
						createTaskInner(saveObject, dateForLogging);
					});
			} else {
				saveObject.categoryNdx = matchedCategory.id;
				createTaskInner(saveObject, dateForLogging);
			}
		}

		function createTaskInner(saveObject, dateForLogging) {
			return procurementTaskService.addAction(saveObject, dateForLogging, factoryNdx)
				.then(function(data) {
					if (!data || data.error) {
						$rootScope.$emit('toast', {
							'message': 'Failed to create task for this item, please try again.',
							'success': false
						});
						vm.formSubmitting = false;
						return;
					}
					if (row) {
						updateRowData(saveObject, data);
					}
					$rootScope.$broadcast('taskAdded', data);
					closeModal();
					$rootScope.$broadcast('refreshTable');
					//only call the service if the tasks updates are coming from my work
					if (($location.url()).indexOf('/my-work') !== -1) {
						notificationService.getUnreadInventoryActions(true);
					}
				});
		}

		function tagTransform(newTag) {
			var item = {
				'name': newTag
			};
			return item;
		};

		function refreshCategoryResults($select) {
			var search = $select.search,
				list = angular.copy($select.items),
				FLAG = -1;
			//remove last user input
			list = list.filter(function (item) {
				return item.id !== FLAG;
			});
	
			if (!search) {
				//use the predefined list
				$select.items = list;
			} else {
				//manually add user input and set selection
				if ($scope.$$childTail.$$childHead && $scope.$$childTail.$$childHead.createProcurementTaskForm) {
					$scope.$$childTail.$$childHead.createProcurementTaskForm.category.$setValidity('task-category', search.length < 128);
				}
				if (search.length > 128) {
					vm.showCategoryMaxLengthError = true;
				} else {
					vm.showCategoryMaxLengthError = false;
					var userInputItem = {
						id: FLAG,
						name: search,
						extraLabel: ' (Click or press Enter to create)'
					};
					$select.items = [userInputItem].concat(list);
					$select.selected = $select.items[0];
					$select.activeIndex = 0;
					$select.activate($select.items[0]);
				}
			}
		}
	}
})();
